
<!-- Modal -->
<div class="modal fade" *ngIf="adminApi.isLoggedIn()" id="{{modalid}}" tabindex="-1" aria-labelledby="suggestskillModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <form class="" [formGroup]="Form" (ngSubmit)="onSubmit(Form)">
        <div class="modal-body pt-4">
          <h5 class="card-title">{{signatureseries?  "Edit Signature Series": "New Signature Series"}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          <div class="form-group">
              <label class="form-label">Title</label>
              <input type="text" class="form-control" formControlName="title">
              <div class="invalid-feedback d-block"
                  *ngIf="f2['title'].errors?.['required'] && (f2['title'].dirty || f2['title'].touched)">
                  Please fill title.
                  
              </div>
          </div>
          <div class="form-group">
            <label class="form-label">Category</label>
            <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="category" class="selectpicker skill font-oswald w-100">
              <option *ngFor="let selectcategory of allcategories" [value]="selectcategory?.id">{{selectcategory?.name | titlecase}}</option>
            </select>
            <div class="invalid-feedback d-block"
                *ngIf="f2['category']?.errors?.['required'] && f2['category'].touched && f2['category']?.invalid">
                Please select category.
            </div>
          </div>
          <div class="form-group">
            <label class="form-label d-block">Background <span class="popover-wrap-3"><i class="fa fa-info-circle"></i><div class="popover-content top">Width: 1015px <br/> Height: 575px</div></span> </label>
            <input type="file" formControlName="background" accept="image/jpg,image/jpeg,image/png" (change)="onSelectFile($event)">
            <div class="invalid-feedback d-block"
                *ngIf="f2['background'].errors?.['background'] && (f2['background'].dirty || f2['background'].touched)">
                Please select png, jpeg or jpg image.
            </div>
            <br *ngIf="imageurl && imageurl!=''"/>
            <br *ngIf="imageurl && imageurl!=''"/>
            <img [src]="imageurl" *ngIf="imageurl && imageurl!=''" height="100">
            <br/>
          </div>
          <div class="form-group">
            <label class="form-label">Instructor</label>
            <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="instructor" class="selectpicker skill font-oswald w-100">
              <option *ngFor="let selectinstructor of allinstructors" [value]="selectinstructor?.id">{{selectinstructor?.name | titlecase}}</option>
            </select>
            <div class="invalid-feedback d-block"
                *ngIf="f2['instructor']?.errors?.['required'] && f2['instructor'].touched && f2['instructor']?.invalid">
                Please select instructor.
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">Description</label>
            <editor
              id="editor"
              formControlName="description"
              [init]="{ plugins: 'lists link image table code help wordcount' }"
              (onInit)="handleEvent($event)"
            ></editor>
          </div>
          <div class="form-group mb-0">
            <label class="form-label">Tags</label>
            <tag-input [separatorKeyCodes]="[32]" [modelAsStrings]="true" formControlName="tags"></tag-input>
          </div>
          
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary me-3" data-bs-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-dark btn-gold">Submit <i *ngIf="submitting" class="fa fa-spinner fa-spin"></i></button>
        </div>
      </form>
    </div>
  </div>
</div>